/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import cx from 'classnames';
/**
 * Input container to wrap inputs with label, and add optional message and icon.
 * @private
 */
export const InputContainer = (props) => {
    var _a;
    const { as: Element = 'div', label, disabled, required, status, message, icon, isLabelInline, isIconInline, children, className, style, statusMessage, ...rest } = props;
    return (React.createElement(Element, { className: cx('iui-input-container', {
            'iui-disabled': disabled,
            [`iui-${status}`]: !!status,
            'iui-inline-label': isLabelInline,
            'iui-inline-icon': isIconInline,
            'iui-with-message': (!!message || !!icon || !!statusMessage) && !isLabelInline,
        }, className), style: style, ...rest },
        label && (React.createElement("div", { className: cx('iui-label', {
                'iui-required': required,
            }) }, label)),
        children,
        statusMessage ? (statusMessage) : (React.createElement(React.Fragment, null,
            icon &&
                React.cloneElement(icon, {
                    className: cx('iui-input-icon', (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className),
                }),
            message && !isLabelInline && (React.createElement("div", { className: 'iui-message' }, message))))));
};
